import { css } from "lit";

export const faqBlockStyles = css`
  .form-field {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  /* Individual FAQ Block */
  .faq-block {
    padding: 16px;
    border-radius: var(--sds-size-radius-400);
    border: 1px solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-secondary);
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow: hidden;

    /* FAQ block entrance and exit animations */
    interpolate-size: allow-keywords;
    transition: all 0.3s ease;
  }

  /* Starting style for new FAQ blocks */
  @starting-style {
    .faq-block {
      opacity: 0;
      transform: translateY(-20px);
      height: 0;
      padding-top: 0;
      padding-bottom: 0;
      margin-bottom: 0;
      border-top-width: 0;
      border-bottom-width: 0;
    }
  }

  /* Removing state for FAQ blocks */
  .faq-block.removing {
    opacity: 0;
    transform: translateY(-20px);
    height: 0;
    padding-top: 0;
    padding-bottom: 0;
    margin-bottom: 0;
    pointer-events: none;
    border-top-width: 0;
    border-bottom-width: 0;
  }

  /* FAQ Block Header */
  .faq-block-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
  }

  .faq-block-number {
    font-size: var(--sds-size-text-body-small-font-size);
    font-weight: var(--sds-size-text-body-medium-font-weight);
    color: var(--sds-color-text-default-secondary);
  }

  .faq-block-header wow-button {
    --button-background: transparent;
    --button-border: 1px solid var(--sds-color-border-default-default);
    --button-color: var(--sds-color-text-default-tertiary);
  }

  .faq-block-header wow-button:hover {
    --button-background: var(--sds-color-background-danger-secondary);
    --button-border: 1px solid var(--sds-color-border-danger-default);
    --button-color: var(--sds-color-text-danger-secondary);
  }
`;
